export function video() {
    let videoBtn = $(".video-play-btn");
    let stopLastFrameVideo = $("video.stope-last-frame");

    const getPlayerParams = (videoSrc) => {
        let srcDefaults = "autoplay=1";//&mute=1&playsinline=1
        let curSrc = videoSrc;
        let isMp4VideoSrc = curSrc.indexOf(".mp4") > -1;
        let src = curSrc;
        if (!isMp4VideoSrc) {
            src = src + (src.indexOf("?") > -1 ? "&" : "?") + srcDefaults;
        }
    
        let playerTemplate = isMp4VideoSrc ? "<video controls autoplay loop name=\"media\"><source src=\"" + src + "\" type=\"video/mp4\"></video>" : "<iframe title=\"video iframe\" src=\"" + src + "\" frameborder=\"0\"  allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
    
        return playerTemplate;
    };

    videoBtn.on("click", function (e) {
        e.preventDefault();
        const videoParent = videoBtn.closest(".video");
        const videoSrc = videoParent.data("video");

        const videoTemplate = getPlayerParams(videoSrc);
        videoParent.addClass("active").html(videoTemplate);
    });

    // stopLastFrameVideo.on("timeupdate", function () {
    //     if (videoEl.currentTime > videoEl.duration - 0.5) {
    //         videoEl.pause();
    //     }
    // });
};


// WEBPACK FOOTER //
// ./assets/js/modules/video.js